﻿<fieldset class="no-legend">
  <div class="column-100">
    <label class="required">Datum rozhodnutí KN</label>
    <div class="input"><input type="text" pick-a-date [(ngModel)]="data.cadastreEntryDeclinedDate" [maxToday]="true"/></div>
  </div>
</fieldset>
